import React, { Component } from "react";
import styles from "./LoggedOut.module.scss";
import { ARTISTS_RANGE } from "../AdminDashboard/constants";
import { get } from "lodash";
import { ThemeContext } from "../../../component/ThemeManager/ThemeManager";
import ContactPopup from "../../../component/ContactPopup";
import HorizontalMenu from "../../../component/HorizontalMenu/HorizontalMenu";
import LoginHeader from "../../../component/LoginHeader";

class LoggedOut extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }


  artistLoggedOut = (status) => {
    switch (status) {
      case ARTISTS_RANGE.SMALL:
      case ARTISTS_RANGE.NEW:
        return (
          <div className={styles.containersm} data-testid="div-small">
            <h3>Thanks for visiting {get(this.context, "displayName")}</h3>
            <h4>We look forward to speaking with you soon!</h4>
          </div>
        );

      case ARTISTS_RANGE.BIG:
        return (
        <div className={styles.containerbig} data-testid="div-big">
          <h3>Thanks for visiting {get(this.context, "displayName")}</h3>
          <h4>
            Keep an eye out for an email from us with more information.
          </h4>
        </div>
        );

      case ARTISTS_RANGE.PENDING:
      case ARTISTS_RANGE.FAILED:
        return (
          <div className={styles.container} data-testid="div-pending">
            <div className={styles.firstContainer}>
              <h3>
                Thanks for visiting {get(this.context, "displayName")}
              </h3>
              <h4>
                Keep an eye out for an email from us when your data is
                ready.
              </h4>
            </div>
            <div className={styles.secondContainer}>
              <h5>The next 3 steps:</h5>
              <div className={styles.getFundedFastDetails}>
                <ol>
                  <li>Verify the data we pulled is correct</li>
                  <li>
                    Customize the Advance Structure that is right for you
                  </li>
                  <li>Upload your distribution reports for review</li>
                </ol>
              </div>
            </div>
          </div>
        );

      default:
        return (
          <div className={styles.container} data-testid="div-default"></div>

        );
    }
  };

  render() {
    const status = get(this.props, "location.state.detail.status")
      ? get(this.props, "location.state.detail.status")
      : get(this.props, "location.state.detail");

    return (
      <div className="layoutContainer">
          <HorizontalMenu
            isLoggedOut={true}
            isDemoDashboard={false}
            {...this.props}
          />
        <div className="funnelContainer">
          <LoginHeader headerTitle="Logged Out" isLoggedOut={true} {...this.props} />
          <div className="pageContainer">
            <div className="mainContainer">
              <div className="scrollContainer">
                {this.artistLoggedOut(status)}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

LoggedOut.contextType = ThemeContext;
export default LoggedOut;
